import { Box, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const ResizableTextBox = ({ Icon, label, placeholder, value, onChange = () => {}, onBlur = () => {}, minHeight = 48, maxHeight = 380, disabled = false, tooltip, rows }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, width: 1 }}>
      <Box sx={{ display: "flex", gap: 0.75 }}>
        {Icon && <Icon size={16} style={{ color: theme.palette.text.navigation, marginTop: "auto", marginBottom: "auto" }} />}
        <Box sx={{ display: label ? "block" : "none" }}>
          <Tooltip title={t(tooltip || "")} arrow placement="right">
            <Typography variant="Textbox Label">{t(label)}</Typography>
          </Tooltip>
        </Box>
      </Box>
      <Box>
        <TextField
          sx={{ "& .MuiInputBase-input": { minHeight: rows ? undefined : minHeight, maxHeight: maxHeight } }}
          fullWidth
          placeholder={t(placeholder)}
          variant="outlined"
          multiline
          rows={rows}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};

export default ResizableTextBox;
